/* HIP&TELL card swatch + per-grid dedupe. Dipindah dari snippets/ht-card-swatch.liquid (2026-09-13) supaya di-cache browser dan tidak menahan parser HTML. Isi identik. */
  (function () {
    if (window.htCardSwatchBound) return;
    window.htCardSwatchBound = true;

    /* One card per style, counted PER GRID. Each colourway is its own product
       sharing one title, so a grid holding all three would repeat it — SKIMS
       shows the style once and lets the dots do the rest. Hidden rather than
       never-rendered: only the duplicates actually present on this page go, so
       a collection curated down to a single colourway still shows it.

       The tally MUST restart at every grid. One tally for the whole page let
       the header's search dropdown decide for the entire site: those six cards
       sit in the DOM of every page and are never on screen until someone opens
       search, yet being first they claimed their styles, and every real card of
       those styles was hidden everywhere. Measured 2026-08-04 — 90's Highwaist
       Straight Jeans and Ashley Flare Jeans rendered nowhere: not on JEANS, not
       on All Products, not in Best Loved. About 1,600 units a shopper could not
       reach. The same tally also made each row swallow whatever the row above
       it had already shown, which is why Best Loved was down to one card.

       A grid is what a shopper reads in one glance, so a grid is the thing that
       must not repeat itself. Keying on the holder's parent gives exactly that
       — verified to separate the search dropdown, the Drops row and the Best
       Loved row into three tallies. */
    function dedupe() {
      /* Gather the whole grid before hiding anything. Which colourway should
         represent a style depends on all of them, not on whichever the
         collection happened to order first — see the pick below. */
      var byGrid = new Map();
      document.querySelectorAll('.ht-card[data-ht-group]').forEach(function (card) {
        var g = card.getAttribute('data-ht-group');
        if (!g) return;
        /* Hide the cell, not the card. Hiding the card alone leaves its grid
           slot standing and the row opens a hole where the duplicate used to
           be (Blywee 2026-08-04: "kenapa jadi kosong ya homepage"). The
           homepage rows wrap each card in .ht-prow__cell, which the earlier
           list did not cover. */
        var holder = card.closest(
          'li, .ht-prow__cell, .product-list__item, [class*="grid__item"], [class*="__cell"]'
        ) || card;
        var grid = holder.parentElement || document.body;
        var groups = byGrid.get(grid);
        if (!groups) { groups = {}; byGrid.set(grid, groups); }
        (groups[g] = groups[g] || []).push({ card: card, holder: holder });
      });

      byGrid.forEach(function (groups) {
        Object.keys(groups).forEach(function (g) {
          var members = groups[g];

          /* Show a colourway someone can actually buy. Keeping the first card
             meant the collection's own order decided it, and that order knows
             nothing about stock: on JEANS and on All Products the style Boston
             Highwaist Mom Jeans wore a Sold Out pill while four of its
             colourways behind it held 80 units between them, and on the
             homepage Clyde Top showed the sage that was gone instead of the
             maroon sitting in the same row with 88. A style is only sold out
             when every one of its colours is, and then the first card is the
             right one to keep. */
          /* 2026-09-10 (Blywee): "Warna utama" (custom.card_primary, stamped as
             data-ht-primary) wins when that colourway is in stock — the
             collection's creation order made Light Blue front Real Wideleg on
             New Denim Drops when Dark Blue was wanted. Sold out primary falls
             back to the stock rule; no primary keeps the old behaviour. */
          var keep = 0, found = false;
          for (var i = 0; i < members.length; i++) {
            if (members[i].card.hasAttribute('data-ht-primary') &&
                !members[i].card.querySelector('.ht-card__soldout-pill')) { keep = i; found = true; break; }
          }
          if (!found) {
            for (var j = 0; j < members.length; j++) {
              if (!members[j].card.querySelector('.ht-card__soldout-pill')) { keep = j; break; }
            }
          }

          members.forEach(function (m, i) {
            /* Only ever undo our own hiding. Something else may have hidden a
               cell — a filter, a section re-render — and that is not ours to
               reverse. Marking it also keeps a re-run idempotent. */
            if (i === keep) {
              if (m.holder.hasAttribute('data-ht-dup')) {
                m.holder.removeAttribute('data-ht-dup');
                m.holder.style.display = '';
              }
            } else if (!m.holder.hasAttribute('data-ht-dup')) {
              m.holder.setAttribute('data-ht-dup', '');
              m.holder.style.display = 'none';
            }
          });
        });
      });
    }

    dedupe();
    document.addEventListener('DOMContentLoaded', dedupe);

    /* Collections paginate and filter in place, so cards arrive after load.
       Watching childList only — hiding a card sets a style, which is an
       attribute change and cannot feed back in here — and coalescing the burst
       a re-render produces into one pass. */
    if (window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(dedupe, 80);
      }).observe(document.documentElement, { childList: true, subtree: true });
    }

    document.addEventListener('click', function (e) {
      var dot = e.target.closest && e.target.closest('[data-ht-swatch]');
      if (!dot) return;
      e.preventDefault();

      var card = dot.closest('.ht-card');
      if (!card) return;

      var src = dot.getAttribute('data-img');
      /* 2026-09-10: tiap titik bawa DUA foto — data-img (kartu diam) dan data-hover
         (kartu disentuh). Dulu dua-duanya diisi src yang sama, jadi setelah ganti
         warna hover-nya diam (laporan Blywee). Tanpa data-hover, hover ikut src. */
      var hov = dot.getAttribute('data-hover') || src;
      if (src) {
        /* srcset has to go or the browser keeps serving the old candidate it already picked. */
        card.querySelectorAll('.ht-card__img--base').forEach(function (img) {
          img.removeAttribute('srcset');
          img.src = src;
        });
        card.querySelectorAll('.ht-card__img--hover').forEach(function (img) {
          img.removeAttribute('srcset');
          img.src = hov;
        });
      }

      var url = dot.getAttribute('data-url');
      if (url) {
        card.querySelectorAll('a[href*="/products/"]').forEach(function (a) { a.href = url; });
      }

      var group = dot.parentElement;
      if (group) {
        group.querySelectorAll('[data-ht-swatch]').forEach(function (d) {
          d.classList.remove('is-selected');
        });
      }
      dot.classList.add('is-selected');
    });
  })();
